// Sidebar entries owned by the Affiliate module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { affiliatePaths } from './paths'

export const affiliateNav = {
    customer: {
        title: 'affiliate:sidebar_customer',
        path: affiliatePaths.affiliatesList,
        // Show the menu to anyone granted the `Affiliates` resource (e.g. Marketing) or,
        // as a fallback, Customers write (CSKH, BOM, Sale) — matching the API gate.
        rsnames: [resources.affiliates, resources.customers],
        require_scopes: [scopes.create],
        visible_permission_denied: false,
    },
    employee: {
        title: 'affiliate:sidebar_employee',
        path: affiliatePaths.employeeAffiliatesList,
        rsname: resources.employees,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
} satisfies Record<string, SidebarType>
